export default import.meta.ROLLDOWN_FILE_URL_WY2oqisrzO4DrVW9CYNGXg